import HeatMapDataLabels from './HeatMapDataLabels.json';
import HeatMapNoDataLabels from './HeatMapNoDataLabels.json';
import HeatMapCompact from './HeatMapCompact.json';
import HeatMapMini1 from './HeatMapMini1.json';
import HeatMapMini2 from './HeatMapMini2.json';
import HeatMapHealthStatus from './HeatMapHealthStatus.json';

export default [
  HeatMapDataLabels,
  HeatMapNoDataLabels,
  HeatMapCompact,
  HeatMapMini1,
  HeatMapMini2,
  HeatMapHealthStatus,
];
